import React, { useState } from 'react';

import styled from 'styled-components';

import { isCommunityCCRC } from 'components/Community/utils';
import { CommunityContract } from 'types/contracts';
import { FeeDataType, FeeType } from 'types/fees';

import Accommodation from './accommodation/Accommodation';
import CareTypeContractSelector from './CareTypeContractSelector';
import { CareTypesContext } from './CareTypesContext';
import CommunityFees from './communityFees/CommunityFees';
import ContractBenefits from './contractBenefits/ContractBenefits';
import Fees from './fees/Fees';
import { CareDataType } from './types';
import HistoryDataModal from '../common/history/HistoryDataModal';
import { useCommunityInfoContext } from '../CommunityInfoContext';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
`;

const Column = styled.div`
  flex: 1;
`;

type Props = {
  careType: CareDataType;
};

const CareTypes = ({ careType }: Props) => {
  const [contract, setContract] = useState<CommunityContract | undefined>(undefined);
  const { communityInfo } = useCommunityInfoContext();
  const { history } = useCommunityInfoContext();
  const [fees, setFees] = useState<FeeDataType>();

  return (
    <CareTypesContext.Provider
      value={{
        careType,
        contract,
        fees,
        setFees,
        setContract,
      }}
    >
      <Container>
        <CareTypeContractSelector />
        <Content>
          {Boolean(history) && <HistoryDataModal />}
          <Column>
            <CommunityFees />
            <Fees type={FeeType.CARE_FEE} />
            <Fees type={FeeType.MEDICATION_FEE} />
            {isCommunityCCRC(communityInfo?.rental_types || []) && <ContractBenefits />}
          </Column>
          <Column>
            <Accommodation />
          </Column>
        </Content>
      </Container>
    </CareTypesContext.Provider>
  );
};

export default CareTypes;
